import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { urlUtility } from "@repo/utilities/url.utility.ts";

interface IGetAllMedicalQuestionsServiceProps {
  page?: string;
  per_page?: string;
  enableQuery?: boolean;
  policyId?: string;
}

// Get Api service for Medical Questions
export const useGetAllMedicalQuestionsService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  policyId,
}: IGetAllMedicalQuestionsServiceProps) => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const questionId = urlQueries["question-id"];

  const allMedicalQuestionsServices = useQuery({
    queryKey: [...CACHE_KEYS.QUESTIONS, page, per_page, policyId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.QUESTIONS,
        searchParams: {
          page,
          per_page,
          ...(policyId && { "filter[questionable_id]": policyId }),
        },
      }),
    enabled: enableQuery,
  });

  const singleMedicalQuestionsService = useQuery({
    queryKey: ["questions", questionId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.QUESTIONS}/${questionId}`,
      }),
    enabled: questionId ? true : false,
  });

  return {
    services: { allMedicalQuestionsServices, singleMedicalQuestionsService },
  };
};
